import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Answer } from '@app/models/questionnaire/answer.model';
import { Question } from '@app/models/questionnaire/question.model';
import { SubmitAnswersModel } from '@app/models/questionnaire/submitAnswers.model';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'question-statement',
  templateUrl: './statement.component.html',
  styleUrls: ['./statement.component.scss']
})
export class StatementComponent implements OnInit, OnDestroy {
  @Input('active')
  isActive: boolean;
  @Input()
  question: Question;
  @Input()
  questionIndex: number;
  @Input('question-changed')
  onQuestionChanged: Subject<boolean>;

  @Output()
  submit: EventEmitter<SubmitAnswersModel> = new EventEmitter<SubmitAnswersModel>();

  subscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.subscription = this.onQuestionChanged.subscribe(isNext => {
      if (!this.isActive) return;
      this.submit.next(new SubmitAnswersModel(isNext, this.getAnswers()));
    });
  }

  getAnswers(): Answer[] {
    let answers: Answer[] = [];

    this.question.options.forEach(o => {
      let answer = new Answer();
      answer.id = o.id;
      answer.selected = true;
      answers.push(answer);
    });

    return answers;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/questions/statement/statement.component.ts